import React from 'react';
import bg from '../Images/About-bg.jpg'
import one from '../Images/About-bg02.png'
function AboutSection() {
  return (
    <div className="bg-[#faf8f3] text-[#1a1a14]">
      <div className="container  flex flex-col md:flex-row items-center  max-w-full">
        {/* Left Image */}
        <div >
          <img
            src={bg}
            alt="Arrangement of green fruits and vegetables including cucumbers, green apples, avocado, and a green juice bottle on a light background with shadows"
            className="w-auto h-[300px] "
          />
        </div>

        {/* Right Content */}
        <div className="flex-1 flex flex-col md:flex-row items-center md:justify-center gap-4 md:gap-10 w-full h-[300px] py-10 md:py-0 " aria-label="Profile information" style={{
                  backgroundImage: `url(${one})`,
                }}>
          {/* Name Section */}
          <div className="flex flex-col max-w-[220px] md:max-w-[220px]" aria-label="Name and title">
            <span className="text-4xl md:text-4xl font-normal">nt.</span>
            <span className="block text-5xl md:text-4xl font-bold mt-[-6px]">Niharika</span>
            <span className="block text-6xl md:text-[4rem] font-bold md:mt-[0px]">Jain</span>
            <div className="text-xl md:text-[18px] md:mt-0 font-normal">(Nutritionist)</div>
          </div>

          {/* Divider */}
          <div className="w-px md:h-[120px] h-px md:w-px bg-[#1a1a14]" aria-hidden="true"></div>

          {/* Info Section */}
          <div className="max-w-[480px] text-lg md:text-xl font-normal leading-[1.3] text-center md:text-start">
            <div className="text-2xl md:text-[35px] font-medium mb-2">With More Than</div>
            <div className='text-2xl md:text-[27px]'>
              <strong className="font-bold">6+</strong> Years of Experience
            </div>
             <div className='text-2xl md:text-[27px]'>
              Served <strong className="font-bold">1,000+</strong> Clients
            </div>
            <div className='text-2xl md:text-[27px]'>
              from Global <strong className="font-bold">10+</strong> Countries
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AboutSection;
